export default "__VITE_ASSET__CFpPGbri__"